import { useState, useEffect } from 'react';
import {
  parseRawNumber,
  formatNumber,
} from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers';
import { formProgression, formError } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  IncomeAndExpenditureFormModel: any;
  setIncomeAndExpenditureFormModel?: any;
  currencyClass?: string;
  averageFoodCost: number;
  hideOtherAdultsIncome: boolean;
  isSubmitting?: boolean;
  isBackhiting?: boolean;
}

const MonthlyIncomeAndExpensesForm = (props: Props) => {
  const {
    Model,
    PageData,
    IncomeAndExpenditureFormModel,
    setIncomeAndExpenditureFormModel,
    currencyClass,
    averageFoodCost,
    hideOtherAdultsIncome,
    isSubmitting,
    isBackhiting,
  } = props;
  console.log('isBackhiting', isBackhiting);
  const [yourIncomePerMonthValueChange, setYourIncomePerMonthValueChange] =
    useState(false);
  const [
    otherAdultsIncomePerMonthValueChange,
    setOtherAdultsIncomePerMonthValueChange,
  ] = useState(false);
  const [showFoodExpenseLowConfirmation, setShowFoodExpenseLowerConfirmation] =
    useState(false);
  const [
    showFoodExpenseHighConfirmation,
    setShowFoodExpenseHigherConfirmation,
  ] = useState(false);

  // Function to add numbers and update total in state
  let incomeExpenseFormValues = {
    ...IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel,
  };
  const calculateIncomeTotal = () => {
    let totalHouseholdIncome =
      parseRawNumber(incomeExpenseFormValues.yourIncome, 2) +
      parseRawNumber(incomeExpenseFormValues.otherAdultsIncome, 2) +
      parseRawNumber(incomeExpenseFormValues.healthcareBenefit, 2) +
      parseRawNumber(incomeExpenseFormValues.housingBenefit, 2) +
      parseRawNumber(incomeExpenseFormValues.otherIncome, 2);

    incomeExpenseFormValues['totalHouseholdIncome'] = formatNumber(
      totalHouseholdIncome,
      ',',
    );
    setIncomeAndExpenditureFormModel({
      ...IncomeAndExpenditureFormModel,
      MonthlyIncomeAndExpensesFormModel: incomeExpenseFormValues,
    });
  };
  const calculateExpenseTotal = () => {
    let totalHouseholdExpenses =
      parseRawNumber(incomeExpenseFormValues.rentOrMortage, 2) +
      parseRawNumber(incomeExpenseFormValues.healthcareInsurance, 2) +
      parseRawNumber(incomeExpenseFormValues.utility, 2) +
      parseRawNumber(incomeExpenseFormValues.water, 2) +
      parseRawNumber(incomeExpenseFormValues.totalInsurance, 2) +
      parseRawNumber(incomeExpenseFormValues.tvAndInternet, 2) +
      parseRawNumber(incomeExpenseFormValues.mobilePhone, 2) +
      parseRawNumber(incomeExpenseFormValues.carCosts, 2) +
      parseRawNumber(incomeExpenseFormValues.monthlyAbility, 2) +
      parseRawNumber(incomeExpenseFormValues.foodExpense, 2) +
      parseRawNumber(incomeExpenseFormValues.otherExpenses, 2);

    incomeExpenseFormValues['totalHouseholdExpenses'] = formatNumber(
      totalHouseholdExpenses,
      ',',
    );
    setIncomeAndExpenditureFormModel({
      ...IncomeAndExpenditureFormModel,
      MonthlyIncomeAndExpensesFormModel: incomeExpenseFormValues,
    });
  };
  function showFoodExpenseLowerConfirmation() {
    return (
      <label id="foodExpenseLowerConfirmation" className="ConfirmationBox">
        <input type="checkbox" className="ConfirmationBox__input" />
        <span className="ConfirmationBox__box"></span>
        <p className="ConfirmationBox__text">
          <span className="ConfirmationBox__warning">
            {PageData?.ExpenseLowerWarningMessage}
          </span>
          {PageData?.PleaseTickTheBoxMessage}
        </p>
      </label>
    );
  }
  function showFoodExpenseHigherConfirmation() {
    return (
      <label id="foodExpenseHigherConfirmation" className="ConfirmationBox">
        <input type="checkbox" className="ConfirmationBox__input" />
        <span className="ConfirmationBox__box"></span>
        <p className="ConfirmationBox__text">
          <span className="ConfirmationBox__warning">
            {PageData?.ExpenseHigherWarningMessage}
          </span>
          {PageData?.PleaseTickTheBoxMessage}
        </p>
      </label>
    );
  }
  const handleFoodExpenseWarning = () => {
    if (
      averageFoodCost * 0.75 >
      parseRawNumber(incomeExpenseFormValues.foodExpense, 2)
    ) {
      setShowFoodExpenseLowerConfirmation(true);
      setShowFoodExpenseHigherConfirmation(false);
    } else if (
      averageFoodCost * 1.25 <
      parseRawNumber(incomeExpenseFormValues.foodExpense, 2)
    ) {
      setShowFoodExpenseHigherConfirmation(true);
      setShowFoodExpenseLowerConfirmation(false);
    }
  };

  function onChangeInputHandler(e: any) {
    incomeExpenseFormValues[e.target.name] = e.target.value;
    setIncomeAndExpenditureFormModel({
      ...IncomeAndExpenditureFormModel,
      MonthlyIncomeAndExpensesFormModel: incomeExpenseFormValues,
    });

    calculateIncomeTotal();
    calculateExpenseTotal();
    handleFoodExpenseWarning();
  }

  useEffect(() => {
    if ((isSubmitting || yourIncomePerMonthValueChange) &&
      !IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel.yourIncome) {
      formError('I&E form', 'yourIncome', 'your income is required')
    }
    if ((isBackhiting || yourIncomePerMonthValueChange) &&
      !IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel.yourIncome) {
      formError('I&E form', 'yourIncome', 'your income is required')
    }
  }, [yourIncomePerMonthValueChange, isSubmitting, isBackhiting, IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel]);

  useEffect(() => {
    if ((isSubmitting || otherAdultsIncomePerMonthValueChange) &&
      !IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel.otherAdultsIncome) {
      formError('I&E form', 'yourIncome', 'other adults income is required')
    }
    if ((isBackhiting || otherAdultsIncomePerMonthValueChange) &&
      !IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel.otherAdultsIncome) {
      formError('I&E form', 'yourIncome', 'other adults income is required')
    }
  }, [otherAdultsIncomePerMonthValueChange, isSubmitting, isBackhiting, IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel]);

  return (
    <div className="IncomeAndExpenditure__formWrapper MonthlyIncomeAndExpenses">
      <form id="incomesAndExpenses" className="IncomeAndExpenditure__form">
        <div className="IncomeAndExpenditure__formInfoWrapper">
          <p className="IncomeAndExpenditure__formInfo">
            {PageData?.FormHeaderNote}
          </p>
        </div>
        <div className="MonthlyIncomeAndExpenses__incomesOverallWrapper">
          <div className="MonthlyIncomeAndExpenses__incomesOverall">
            <label className="IncomeAndExpenditure__label IncomeAndExpenditure__label--center-align">
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.YourIncomePerMonthLabel}
              </span>
              <div
                className={
                  'Input Input-icon Input-icon--before ' +
                  currencyClass +
                  ' Input-textCenter'
                }
              >
                <input
                  type="number"
                  name="yourIncome"
                  value={
                    IncomeAndExpenditureFormModel
                      .MonthlyIncomeAndExpensesFormModel.yourIncome
                  }
                  className={
                    'incomes-to-calculate' +
                    ' ' +
                    ((isSubmitting || yourIncomePerMonthValueChange) &&
                      !IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel.yourIncome
                      ? 'error'
                      : '') +
                    ' ' +
                    ((isBackhiting || yourIncomePerMonthValueChange) &&
                      !IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel.yourIncome
                      ? 'error'
                      : '')
                  }
                  required
                  placeholder={PageData?.InputAmountPlaceHolderText}
                  onChange={(val) => {
                    onChangeInputHandler(val);
                    setYourIncomePerMonthValueChange(true);
                  }}
                  onBlur={(e) => formProgression(e, 'I&E form', 'yourIncome')}
                />
                <span></span>
              </div>
            </label>

            <label
              id="otherAdultsIncome"
              className={
                'IncomeAndExpenditure__label IncomeAndExpenditure__label--center-align' +
                (hideOtherAdultsIncome
                  ? ' MonthlyIncomeAndExpenses__incomesOverall--oneInRow'
                  : '')
              }
            >
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.OtherAdultsIncomePerMonthLabel}
              </span>
              <div
                className={
                  'Input Input-icon Input-icon--before ' +
                  currencyClass +
                  ' Input-textCenter'
                }
              >
                {!hideOtherAdultsIncome && (
                  <>
                    <input
                      type="number"
                      name="otherAdultsIncome"
                      value={
                        IncomeAndExpenditureFormModel
                          .MonthlyIncomeAndExpensesFormModel.otherAdultsIncome
                      }
                      className={
                        'incomes-to-calculate' +
                        ' ' +
                        ((isSubmitting ||
                          otherAdultsIncomePerMonthValueChange) &&
                          !IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.otherAdultsIncome
                          ? 'error'
                          : '') +
                        ' ' +
                        ((isBackhiting ||
                          otherAdultsIncomePerMonthValueChange) &&
                          !IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.otherAdultsIncome
                          ? 'error'
                          : '')
                      }
                      required
                      placeholder={PageData?.InputAmountPlaceHolderText}
                      onChange={(val) => {
                        onChangeInputHandler(val);
                        setOtherAdultsIncomePerMonthValueChange(true);
                      }}
                      onBlur={(e) => formProgression(e, 'I&E form', 'otherAdultsIncome')}
                    />
                    <span></span>
                  </>
                )}
              </div>
            </label>
          </div>
        </div>
        <div className="MonthlyIncomeAndExpenses__grid">
          <div id="incomes" className="MonthlyIncomeAndExpenses__incomes">
            <div className="MonthlyIncomeAndExpenses__section MonthlyIncomeAndExpenses__section--border-bottom">
              <h5 className="IncomeAndExpedinture__heading">
                {PageData?.OtherHouseHoldIncomePerMonthLabel}
              </h5>
              <label className="IncomeAndExpenditure__label">
                <span className="IncomeAndExpenditure__labelText">
                  {PageData?.HealthCareBenefitLabel}
                </span>
                <div
                  className={
                    'Input Input-icon Input-icon--before' + currencyClass
                  }
                >
                  <input
                    type="number"
                    name="healthcareBenefit"
                    value={
                      IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel.healthcareBenefit
                    }
                    className="incomes-to-calculate"
                    placeholder={PageData?.InputAmountPlaceHolderText}
                    onChange={(val) => onChangeInputHandler(val)}
                    onBlur={(e) => formProgression(e, 'I&E form', 'healthcareBenefit')}
                  />
                  <span></span>
                </div>
              </label>
              <label className="IncomeAndExpenditure__label">
                <span className="IncomeAndExpenditure__labelText">
                  {PageData?.HousingBenefitLabel}
                </span>
                <div
                  className={
                    'Input Input-icon Input-icon--before' + currencyClass
                  }
                >
                  <input
                    type="number"
                    name="housingBenefit"
                    value={
                      IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel.housingBenefit
                    }
                    className="incomes-to-calculate"
                    placeholder={PageData?.InputAmountPlaceHolderText}
                    onChange={(val) => onChangeInputHandler(val)}
                    onBlur={(e) => formProgression(e, 'I&E form', 'housingBenefit')}
                  />
                  <span></span>
                </div>
              </label>
              <label className="IncomeAndExpenditure__label">
                <span className="IncomeAndExpenditure__labelText">
                  {PageData?.OtherIncomeLabel}
                </span>
                <div
                  className={
                    'Input Input-icon Input-icon--before' + currencyClass
                  }
                >
                  <input
                    type="number"
                    name="otherIncome"
                    value={
                      IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel.otherIncome
                    }
                    className="incomes-to-calculate"
                    placeholder={PageData?.InputAmountPlaceHolderText}
                    onChange={(val) => onChangeInputHandler(val)}
                    onBlur={(e) => formProgression(e, 'I&E form', 'otherIncome')}
                  />
                  <span></span>
                </div>
              </label>
            </div>
            <div className="MonthlyIncomeAndExpenses__incomesSummary">
              <div className="MonthlyIncomeAndExpenses__section">
                <label className="IncomeAndExpenditure__label IncomeAndExpenditure__label--center-align">
                  <span className="IncomeAndExpenditure__labelText">
                    {PageData?.TotalHouseHoldIncomePerMonthLabel}
                  </span>
                  <div
                    className={
                      'Input Input-icon Input-icon--before' + currencyClass
                    }
                  >
                    <input
                      type="text"
                      name="totalHouseholdIncome"
                      value={
                        IncomeAndExpenditureFormModel
                          .MonthlyIncomeAndExpensesFormModel
                          .totalHouseholdIncome
                      }
                      className="non-editable"
                      readOnly
                      placeholder={PageData?.InputAmountPlaceHolderText}
                      onBlur={(e) => formProgression(e, 'I&E form', 'totalHouseholdIncome')}
                    />
                    <span></span>
                  </div>
                </label>
                <p className="IncomeAndExpenditure__formRequiredText u-lg-hidden">
                  {PageData?.TheseAreRequiredFieldsText}
                </p>
              </div>
              <div className="MonthlyIncomeAndExpenses__expectedIncomes">
                <label className="IncomeAndExpenditure__label">
                  <span className="IncomeAndExpenditure__labelText IncomeAndExpenditure__labelText--large-margin">
                    {PageData?.ExpectChangeInHouseHoldIncomeLabel}
                  </span>
                  <div className="IncomeAndExpenditure__checkboxGroup">
                    <label className="Checkbox">
                      <input
                        type="radio"
                        name="isExpectingIncomes"
                        value="no"
                        checked
                        className="Checkbox__input"
                        onChange={(val) => onChangeInputHandler(val)}
                      />
                      <span className="Checkbox__box"></span>
                      <span className="Checkbox__label">
                        {PageData?.NoCheckBoxLabel}
                      </span>
                    </label>
                    <label className="Checkbox">
                      <input
                        type="radio"
                        name="isExpectingIncomes"
                        value="yes"
                        className="Checkbox__input"
                        onChange={(val) => onChangeInputHandler(val)}
                      />
                      <span className="Checkbox__box"></span>
                      <span className="Checkbox__label">
                        {PageData?.YesCheckBoxLabel}
                      </span>
                    </label>
                  </div>
                  <textarea
                    name="expectedHouseholdIncome"
                    className="IncomeAndExpenditure__textArea"
                    placeholder={PageData?.PleaseSpecifyWhyPlaceHolderText}
                    value={
                      IncomeAndExpenditureFormModel
                        .MonthlyIncomeAndExpensesFormModel
                        .expectedHouseholdIncome
                    }
                    onChange={(val) => onChangeInputHandler(val)}
                    onBlur={(e) => formProgression(e, 'I&E form', 'expectedHouseholdIncome')}
                  ></textarea>
                </label>
              </div>
            </div>
          </div>
          <div id="expenses" className="MonthlyIncomeAndExpenses__expenses">
            <div className="MonthlyIncomeAndExpenses__section MonthlyIncomeAndExpenses__section--full-height">
              <h5 className="IncomeAndExpedinture__heading">
                {PageData?.MonthlyHouseHoldExpensesLabel}
              </h5>
              <div className="MonthlyIncomeAndExpenses__expensesWrapper">
                <div className="MonthlyIncomeAndExpenses__expensesColumn">
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.RentMortgagePayment}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="rentOrMortage"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.rentOrMortage
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'rentOrMortage')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.HealthCareInsurance}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="healthcareInsurance"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel
                            .healthcareInsurance
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'healthcareInsurance')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.Utility}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="utility"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.utility
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'utility')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.Water}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="water"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.water
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'water')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.TotalInsurancePackage}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="totalInsurance"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.totalInsurance
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'totalInsurance')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.TvAndInternet}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="tvAndInternet"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.tvAndInternet
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'tvAndInternet')}
                      />
                      <span></span>
                    </div>
                  </label>
                </div>
                <div className="MonthlyIncomeAndExpenses__expensesColumn">
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.MobilePhone}
                    </span>
                    <div
                      className={
                        'Input Input-icon  Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="mobilePhone"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.mobilePhone
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'mobilePhone')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.CarCosts}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="carCosts"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.carCosts
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'carCosts')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.Groceries}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="foodExpense"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.foodExpense
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'foodExpense')}
                      />
                      <span></span>
                    </div>
                  </label>

                  {IncomeAndExpenditureFormModel
                    .MonthlyIncomeAndExpensesFormModel.foodExpense &&
                    showFoodExpenseHighConfirmation &&
                    showFoodExpenseHigherConfirmation()}
                  {IncomeAndExpenditureFormModel
                    .MonthlyIncomeAndExpensesFormModel.foodExpense &&
                    showFoodExpenseLowConfirmation &&
                    showFoodExpenseLowerConfirmation()}

                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.MonthlyAbllity}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="monthlyAbility"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.monthlyAbility
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'monthlyAbility')}
                      />
                      <span></span>
                    </div>
                  </label>
                  <label className="IncomeAndExpenditure__label">
                    <span className="IncomeAndExpenditure__labelText">
                      {PageData?.OtherExpenses}
                    </span>
                    <div
                      className={
                        'Input Input-icon Input-icon--before' + currencyClass
                      }
                    >
                      <input
                        type="number"
                        name="otherExpenses"
                        value={
                          IncomeAndExpenditureFormModel
                            .MonthlyIncomeAndExpensesFormModel.otherExpenses
                        }
                        className="expenses-to-calculate"
                        placeholder={PageData?.InputAmountPlaceHolderText}
                        onChange={(val) => onChangeInputHandler(val)}
                        onBlur={(e) => formProgression(e, 'I&E form', 'otherExpenses')}
                      />
                      <span></span>
                    </div>
                  </label>
                </div>
              </div>
              <div className="MonthlyIncomeAndExpenses__expensesSummary">
                <label className="IncomeAndExpenditure__label IncomeAndExpenditure__label--center-align">
                  <span className="IncomeAndExpenditure__labelText">
                    {PageData?.TotalHouseHoldExpenses}
                  </span>
                  <div
                    className={
                      'Input Input-icon Input-icon--before' +
                      currencyClass +
                      ' Input-textCenter'
                    }
                  >
                    <input
                      type="text"
                      name="totalHouseholdExpenses"
                      value={
                        IncomeAndExpenditureFormModel
                          .MonthlyIncomeAndExpensesFormModel
                          .totalHouseholdExpenses
                      }
                      className="non-editable"
                      readOnly
                      placeholder={PageData?.InputAmountPlaceHolderText}
                      onBlur={(e) => formProgression(e, 'I&E form', 'totalHouseholdExpenses')}
                    />
                    <span></span>
                  </div>
                </label>
                <p className="IncomeAndExpenditure__formRequiredText u-xsm-hidden u-lg-flex">
                  {PageData?.TheseAreRequiredFieldsText}
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default MonthlyIncomeAndExpensesForm;
